import { render, staticRenderFns } from "./backButton.vue?vue&type=template&id=2b864fb8&scoped=true"
var script = {}
import style0 from "./backButton.vue?vue&type=style&index=0&id=2b864fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b864fb8",
  null
  
)

export default component.exports